// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { TextFieldProps } from "@steiner/MobiusOverrides/TextField/TextField";
import { createUserModalStyles } from "@steiner/Overrides/Widgets/UserList/CreateUserModal";
import AlertInfo from "@steiner/XDL/Icons/AlertInfo";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

createUserModalStyles.roleSelectHelpIcon = {
    src: AlertInfo,
    size: 14,
    color: "common.ui8",
};

createUserModalStyles.approverSelectTooltip = {
    iconProps: {
        size: 14,
        src: AlertInfo,
        color: "common.ui8",
    },
    mergeCss: true,
};

createUserModalStyles.approverSelectLabelWrapper = createUserModalStyles.roleSelectLabelWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;

        ${IconWrapper} {
            cursor: pointer;
            vertical-align: middle;
            &:hover {
                color: ${color("common.ui9")};
            }
        }
    `,
};

createUserModalStyles.settingsHeadingGridItem = {
    width: 12,
    css: css`
        position: relative;
        padding-block: 14px;
        &&& {
            margin-bottom: 8px;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: calc(100% - 15px);
            height: 1px;
            background-color: ${getColor("common.border")};
            margin: 0 auto;
        }
    `,
};

createUserModalStyles.settingsHeadingText = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

createUserModalStyles.userNameTextField = {
    placeholder: translate("Username"),
} as TextFieldProps;

createUserModalStyles.emailTextField = {
    placeholder: translate("Email"),
} as TextFieldProps;

createUserModalStyles.firstNameTextField = {
    placeholder: translate("First Name"),
} as TextFieldProps;

createUserModalStyles.lastNameTextField = {
    placeholder: translate("Last Name"),
} as TextFieldProps;

createUserModalStyles.buttonsGridItem = {
    css: css`
        justify-content: flex-end;
        gap: 10px;
        padding-top: 14px;
        ${xScreen("lt", "xs")} {
            flex-direction: column-reverse;
        }
    `,
    width: 12,
};

createUserModalStyles.termsLink = {
    css: css`
        margin-left: 5px;
    `,
}

createUserModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

createUserModalStyles.submitButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

createUserModalStyles.userNameVisibleGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.emailGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.firstNameGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.lastNameGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.roleGridItem = { width: [12, 6, 6, 6, 6] };
createUserModalStyles.approverGridItem = { width: [12, 6, 6, 6, 6] };

createUserModalStyles.acceptConditions = {
    css: css`
        ${StyledButton} ${TypographyStyle} {
            font-size: 12px;
            line-height: 12px;
        }
    `,
    mergeCss: true,
};
